import React from 'react';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Button as MButton,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const DialogComponent = ({
							 open,
							 onClose,
							 title,
							 description,
							 children,
							 IconComponent,
							 buttonLabel,
							 buttonColor,
							 titleColor,
							 iconColor,
							 showConfirmButton,
							 onConfirm,
							 confirmLabel,
							 confirmColor,
							 maxWidth,
							 fullWidth,
							 fullScreen,
	                         confirmVariant,
	                         confirmBackground
						 }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="dialog-title"
			aria-describedby="dialog-description"
			maxWidth={maxWidth}
			fullWidth={fullWidth}
			fullScreen={fullScreen}
		>
			<DialogTitle id="dialog-title" style={{ color: titleColor, display: 'flex', alignItems: 'center' }}>
				{IconComponent && (
					<IconComponent style={{ color: iconColor, fontSize: 25, marginRight: 8 }} />
				)}
				{title}
			</DialogTitle>

			<DialogContent>
				{description && typeof description === 'string' ? (
					<DialogContentText id="dialog-description">{description}</DialogContentText>
				) : (
					description || children || null
				)}
			</DialogContent>

			<DialogActions>
				<MButton onClick={onClose} style={{ color: buttonColor }}>
					{buttonLabel}
				</MButton>
				{showConfirmButton && (
					<MButton variant={confirmVariant} onClick={onConfirm}
					         style={{color: confirmColor, backgroundColor: confirmBackground}}>
						{confirmLabel}
					</MButton>
				)}
			</DialogActions>
		</Dialog>
	);
};

DialogComponent.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	children: PropTypes.node,
	IconComponent: PropTypes.elementType,
	buttonLabel: PropTypes.string.isRequired,
	buttonColor: PropTypes.string,
	titleColor: PropTypes.string,
	iconColor: PropTypes.string,
	showConfirmButton: PropTypes.bool,
	onConfirm: PropTypes.func,
	confirmLabel: PropTypes.string,
	confirmColor: PropTypes.string,
	maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
	fullWidth: PropTypes.bool,
	fullScreen: PropTypes.bool,
	confirmVariant: PropTypes.string,
	confirmBackground: PropTypes.string
};

DialogComponent.defaultProps = {
	description: null,
	children: null,
	IconComponent: null,
	buttonColor: '#9cc54b',
	titleColor: '#000',
	iconColor: 'red',
	showConfirmButton: false,
	onConfirm: () => {},
	confirmLabel: 'Confirm',
	confirmColor: '#1976d2',
	maxWidth: 'sm',
	fullWidth: true,
	fullScreen: false,
	confirmVariant: "text",
	confirmBackground: "transparent"
};

export default DialogComponent;
